import { render, staticRenderFns } from "./floatBox.vue?vue&type=template&id=c9e3e518&"
import script from "./floatBox.vue?vue&type=script&lang=js&"
export * from "./floatBox.vue?vue&type=script&lang=js&"
import style0 from "./floatBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports